module.exports = __webpack_public_path__ + "img/m5-5h.b68e34f0.png";